import { render, staticRenderFns } from "./NewReservationModal.vue?vue&type=template&id=3891d3f2&"
import script from "./NewReservationModal.vue?vue&type=script&lang=js&"
export * from "./NewReservationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports